var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 14.0853C28 6.30617 21.7321 0 14.0002 0C6.26823 0 0 6.30617 0 14.0853C0 21.1159 5.11948 26.9433 11.8124 28V18.1569H8.25775V14.0853H11.8124V10.9824C11.8124 7.45223 13.9027 5.50209 17.1005 5.50209C18.6324 5.50209 20.2345 5.77714 20.2345 5.77714V9.24377H18.4691C16.73 9.24377 16.1876 10.3293 16.1876 11.4432V14.0867H20.0702L19.4496 18.1569H16.1876V28C22.8805 26.9433 28 21.1159 28 14.0853Z","fill":"#0C5964"}));
}

FacebookIcon.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
